import Core from "@/core/index.js"
import coreConfig from "../core.config.js"

window.core = new Core(coreConfig)